<template>
    <div>
        <h3 class="title is-4">CoP Information</h3>
        
        <div v-if="loading == true" class="notification is-warning">
            Loading ...
        </div>

        <div v-if="loading==false">
            

            <div class="field">
                <label class="label">CoP Registration Number</label>
                <div class="control">
                    <input class="input" type="text" v-model="member.cop_registration_number" >
                </div>
            </div>

            <div class="field">
                <label class="label">Date Recorded By Balmoral</label>
                <div class="control">
                    <input class="input" type="date" v-model="member.cop_recorded_date" >
                </div>
            </div>

            <div class="field">
                <label class="label">CoP Certificate Expiry Date</label>
                <div class="control">
                    <input class="input" type="date" v-model="member.cop_certificate_expiry" >
                </div>
            </div>

            <div class="field">
                <label class="label">Indemnity Cover Insurance Expiry Date</label>
                <div class="control">
                    <input class="input" type="date" v-model="member.cop_insurance_expiry" >
                </div>
            </div>

            <div class="field">
                <label class="label">Last Checked On</label>
                <div class="control">
                    <input class="input" type="date" v-model="member.cop_last_checked" disabled readonly>
                    <small>This date will change when the Update button is pressed. Even if no details have been updated.</small>
                </div>
            </div>

           
            <div class="field ">
                <div class="control">
                    <button class="button is-success" :disabled="working===true" @click="updateCop()">Update Details</button>
                </div>
            </div>
           

           
        </div>
    </div>
</template>

<script>
import MemberMixin from '@/mixins/MemberMixin.js';

import MemberService from '@/services/MemberService.js';

export default {
    name: 'MemberNmc',
  data() {
    return {
      count: 0,
      loading: false,
      working: false
    }
  },
  mixins: [MemberMixin],
  props: ['member'],
  methods: {
        
        async updateCop() {
			this.working = true
            var formdata = { 
                _method: 'patch',
                cop_registration_number: this.member.cop_registration_number,
                cop_recorded_date: this.member.cop_recorded_date,
                cop_certificate_expiry: this.member.cop_certificate_expiry,
                cop_insurance_expiry: this.member.cop_insurance_expiry
            }; 

            MemberService.updateMember(this.accessToken, formdata, this.member.id)
            .then((response) => {
                this.$emit('reload-member')
                console.log(response)
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.working = false
            });
        },
        
        
    },
    created() {
            this.getAccessToken()
            .then(() => { 
                
            });
        
        },
}
</script>